module.exports = __webpack_public_path__ + "img/swe.fd663a70.svg";